"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerLevelsListCtl = /** @class */ (function (_super) {
    __extends(PlayerLevelsListCtl, _super);
    function PlayerLevelsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_level_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_tag; });
        _this.dk_level_num = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_num; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_level_offers_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_offers_count; });
        _this.dk_min_bet_amounts = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_bet_amounts; });
        _this.dk_min_points_amount_2_exchange = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_points_amount_2_exchange; });
        _this.dk_points_exchange_rate = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_exchange_rate; });
        _this.dk_cashback_bonus_percent_x100 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cashback_bonus_percent_x100; });
        _this.dk_cashback_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cashback_bonus_wager; });
        _this.dk_birthday_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_bonus_wager; });
        _this.dk_birthday_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_bonus_amount; });
        _this.dk_level_access_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_access_bonus_wager; });
        _this.dk_level_access_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_access_bonus_amount; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerLevelsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerLevelsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player level with id [" + id + "] not found !";
    };
    PlayerLevelsListCtl.prototype.LoadData = function (AllBrands, BrandIdList, allCurrency, currencyId, onDone) {
        var _this = this;
        webAApi_1.ListBrandPlayerLevelsByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList,
            all_currencies: allCurrency,
            app_currency_id: currencyId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    level_tag: resp.list[i].level_tag,
                    level_num: resp.list[i].level_num,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    level_offers_count: resp.list[i].level_offers_count,
                    min_bet_amounts: resp.list[i].min_bet_amounts,
                    min_points_amount_2_exchange: resp.list[i].min_points_amount_2_exchange,
                    points_exchange_rate: resp.list[i].points_exchange_rate,
                    cashback_bonus_percent_x100: resp.list[i].cashback_bonus_percent_x100,
                    cashback_bonus_wager: resp.list[i].cashback_bonus_wager,
                    birthday_bonus_amount: resp.list[i].birthday_bonus_amount,
                    birthday_bonus_wager: resp.list[i].birthday_bonus_wager,
                    level_access_bonus_wager: resp.list[i].level_access_bonus_wager,
                    level_access_bonus_amount: resp.list[i].level_access_bonus_amount
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandPlayerLevel.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                level_tag: data.level_tag,
                level_num: data.level_num,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                level_tag: data.level_tag,
                level_num: data.level_num,
                title: data.title,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                description: data.description,
                level_offers_count: 0,
                min_bet_amounts: resp.not_found_text,
                min_points_amount_2_exchange: resp.not_found_text,
                points_exchange_rate: resp.not_found_text,
                cashback_bonus_percent_x100: resp.not_found_text,
                cashback_bonus_wager: resp.not_found_text,
                birthday_bonus_amount: resp.not_found_text,
                birthday_bonus_wager: resp.not_found_text,
                level_access_bonus_wager: resp.not_found_text,
                level_access_bonus_amount: resp.not_found_text,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandPlayerLevel.exec({
                data: {
                    brand_player_level_id: data.key,
                    title: data.title,
                    level_tag: data.level_tag,
                    level_num: data.level_num,
                    description: data.description
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.level_tag = data.level_tag;
                _tmp.level_num = data.level_num;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerLevelsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerLevelsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandPlayerLevel.exec({
                data: {
                    brands_player_level_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerLevelsListCtl;
}(BaseController_1.BaseController));
exports.PlayerLevelsListCtl = PlayerLevelsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ctl/PlayersLevelsListCtl.ts
// module id = 882
// module chunks = 0